/**
 * 放置全局一些通用配置
 */
// import { HyperDevice } from "kaihong-hyper-device";
export const DEFAULT_DATA = "--";

// export const hyperDevice = new HyperDevice();
